import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { RoomSettingsContainerComponent } from '@rocksoft/places';

@Injectable()
export class RoomSettingsDeactivateGuard {
  constructor(private readonly router: Router) {}
  private readonly regex = new RegExp('/locations/[A-Za-z0-9]+/floors/[A-Za-z0-9]+/rooms/[A-Za-z0-9]+/?(.+|$)');

  canDeactivate: CanDeactivateFn<RoomSettingsContainerComponent> = (
    component: RoomSettingsContainerComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) => {
    const nextStateSplit = nextState.url.split('/');
    const matchedNext = this.regex.exec(nextState.url);
    const matchedCurrent = this.regex.exec(currentState.url);

    if (matchedCurrent && matchedNext && matchedCurrent[1] && !matchedNext[1]) {
      const tab = matchedCurrent[1].split('/');
      nextStateSplit.push(...tab);
      void this.router.navigate(nextStateSplit);
    }
    return true;
  };
}
